import React from 'react';
import { MESSAGE_LOCATION } from 'models/Message';
import Chat from './pages/Chat';
import { EnhancedRouteProps } from 'router/routes/Enhanced/Enhanced.route';

export default [
  {
    path: ':sessionId',
    element: (
      <Chat
        showButtons
        showUserData
        messageLocation={MESSAGE_LOCATION.MESSAGING_PAGE}
      />
    ),
  },
] as Array<EnhancedRouteProps>;
